module.exports = __webpack_public_path__ + "img/icn_resize.bf923fff.svg";